<template>
    <div @click="callback($event)" class="secondary-button" role="button"><slot></slot></div>
</template>

<script>
    module.exports = {
      props: {
        type: String,
        disabled: Boolean
      },
      methods: {
        callback: function(e) {
          this.$emit('click', e);
        }
      }
      // data: function() {
      //   return {
      //        title: ''
      //   }
      // }
    }
</script>

<style scoped lang="scss">

    @import './variables';

    .secondary-button {
        color: $primary-blue;
        font-family: $font;
        font-size: 0.8rem;
        display: inline-block;
        cursor: pointer;
        &[disabled]{
            cursor: not-allowed;
        }
        &.danger {
            color: #ff4949;
        }
        &.success {
            color: #13ce66;
        }
        &.info {
            color: #50bfff;
        }
    }

</style>
